
import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function CloseIcon(props) {
    const { style } = props;
    const classes = useStyles(props)()

    return(
        <svg className={classes.container} style={style} width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 0C5.83187 0 0 5.60757 0 12.5C0 19.3924 5.83187 25 13 25C20.1681 25 26 19.3924 26 12.5C26 5.60757 20.1681 0 13 0ZM18.4144 16.3462C19.8824 17.7577 18.4144 19.0661 17 17.7061C15.5856 16.3462 13 13.86 13 13.86C13 13.86 10.4144 16.3462 9 17.7061C7.58562 19.0661 6.17125 17.7061 7.58562 16.3462C9 14.9862 11.5856 12.5 11.5856 12.5C11.5856 12.5 9 10.0138 7.58562 8.65385C6.17125 7.29387 7.64706 5.99296 9 7.29387C10.3529 8.59477 13 11.14 13 11.14C13 11.14 15.6471 8.59478 17 7.29387C18.3529 5.99296 19.7673 7.35294 18.4144 8.65385C17.0614 9.95475 14.4144 12.5 14.4144 12.5C14.4144 12.5 16.9464 14.9346 18.4144 16.3462Z" fill="#2196C0"/>
        </svg>
    )
}


const useStyles = props => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: props.color,
            width: props.width,
         },
    }
}));